var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"copy-btn fa fa-fw fa-copy",attrs:{"title":"Click to copy"},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }